const generateHeader = (dataCopy, idx, key, indexCargo, length) => {
  console.log('dataCopy::: ', dataCopy)
  console.log('idx::: ', idx)
  console.log('key::: ', key)
  console.log('indexCargo::: ', indexCargo)
  console.log('length::: ', length)
  
  let header = {}
  if(length > 1) {
    const descPlan = dataCopy[idx].Horarios.find(e => e.IdHorario === key)['DescripcionPlan']
    const nombrePlan = dataCopy[idx].Horarios.find(e => e.IdHorario === key)['NombrePlan']
    //const a = dataCopy[indexCargo]['Horarios'].find(e => e.IdHorario === key)
    const a = dataCopy[idx].Horarios.find(e => e.IdHorario === key)
    console.log('item: ', a)
    header.IdCurso   = dataCopy[idx]?.IdCurso
    header.DescripcionPlan = descPlan //a?.DescripcionPlan
    header.IdHorario = a?.IdHorario
    header.IdPlan    = a?.IdPlan
    header.NombrePlan = nombrePlan
    header.IdPeriodo = a?.IdPeriodo
  }else{
    header.IdCurso   = dataCopy[idx]?.IdCurso
    header.IdHorario = dataCopy[idx]?.Horarios[0]["IdHorario"]
    header.IdPlan    = dataCopy[idx]?.Horarios[0]["IdPlan"]
    header.IdPeriodo = dataCopy[idx]?.Horarios[0]["IdPeriodo"]
    header.NombrePlan = dataCopy[idx].Horarios.find(e => e.IdHorario === key)['NombrePlan']
    header.DescripcionPlan = dataCopy[idx].Horarios.find(e => e.IdHorario === key)['DescripcionPlan']// dataCopy[idx]['Horarios'][idx]?.DescripcionPlan
  }
    console.log('HEADER::: ', header)
    return header
  }


  
  export {
    generateHeader,
  }